export enum PaStatus {
  APPROVED = "Approved",
  DENIED = "Denied",
  PENDING = "Pending",
  APPEAL_PENDING = "Appeal Pending",
  AUTH_NOT_REQUIRED = "Auth Not Required",
  ONSHORE_ASSISTANCE = "Onshore Assistance",
  NA_OUTCOME = "NA Outcome",
}

export const PaStatusLabels: Record<PaStatus, string> = {
  [PaStatus.APPROVED]: "Approved",
  [PaStatus.DENIED]: "Denied",
  [PaStatus.PENDING]: "Pending",
  [PaStatus.APPEAL_PENDING]: "Appeal Pending",
  [PaStatus.AUTH_NOT_REQUIRED]: "Auth Not Required",
  [PaStatus.ONSHORE_ASSISTANCE]: "Onshore Assistance",
  [PaStatus.NA_OUTCOME]: "NA Outcome",
};
